/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_BoxingInputs */

const en_service_type_boxing = /** @type {(inputs: Service_Type_BoxingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boxing`)
};

const pl_service_type_boxing = /** @type {(inputs: Service_Type_BoxingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boks`)
};

/**
* | output |
* | --- |
* | "Boxing" |
*
* @param {Service_Type_BoxingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_boxing = /** @type {((inputs?: Service_Type_BoxingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_BoxingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_boxing(inputs)
	return en_service_type_boxing(inputs)
});